import { render, staticRenderFns } from "./DsrDetail.vue?vue&type=template&id=06fda3c3&scoped=true&"
import script from "./DsrDetail.vue?vue&type=script&lang=js&"
export * from "./DsrDetail.vue?vue&type=script&lang=js&"
import style0 from "./DsrDetail.vue?vue&type=style&index=0&id=06fda3c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fda3c3",
  null
  
)

export default component.exports